import { create } from 'zustand';
import { useDeviceStore } from './deviceStore';

interface SpeedAnalysisState {
  startFrame: number | null;
  endFrame: number | null;
  distance: number;
  fps: number;
  setStartFrame: (frame: number) => void;
  setEndFrame: (frame: number) => void;
  setDistance: (distance: number) => void;
  setFps: (fps: number) => void;
  reset: () => void;
  calculateResults: () => {
    frameCount: number;
    time: number;
    speed: number;
    distance: number;
  } | null;
}

export const useSpeedAnalysisStore = create<SpeedAnalysisState>((set, get) => ({
  startFrame: null,
  endFrame: null,
  distance: 10,
  fps: 240,
  setStartFrame: (frame) => set({ startFrame: frame }),
  setEndFrame: (frame) => set({ endFrame: frame }),
  setDistance: (distance) => set({ distance }),
  setFps: (fps) => set({ fps }),
  reset: () => set({ startFrame: null, endFrame: null }),
  calculateResults: () => {
    const { startFrame, endFrame, distance, fps } = get();
    if (startFrame === null || endFrame === null) return null;

    const deviceType = useDeviceStore.getState().deviceType;
    
    // iPhoneの場合は4で割って補正、PCの場合はそのまま
    let frameCount = Math.abs(endFrame - startFrame) / (deviceType === 'iphone' ? 4 : 1);
    
    // 120fpsと240fpsの場合はフレーム数を半分にする
    if (fps >= 120) {
      frameCount = frameCount / 2;
    }
    
    // 新しい計算式
    const time = frameCount / fps; // フレーム数/fps
    const speed = distance / (frameCount * (1/fps)); // 距離/(フレーム数×(1/fps))

    return {
      frameCount,
      time,
      speed,
      distance,
    };
  },
}));